export default __webpack_public_path__ + "static/media/icon_logo.332cabd9.svg";